import { SyntheticEvent } from 'react';

import { useOperationTraders } from 'api/requests/operation';
import { useSearchDebounce } from 'hooks/useSearchDebounce';
import { useTranslation } from 'libs/i18n';
import { Field } from 'modules/operation/common/forms/operationForm';

export const TraderAutocompleteFeature = () => {
  const { t } = useTranslation();

  const { search, debouncedFunc } = useSearchDebounce();

  const { listData, loading } = useOperationTraders({
    pagination: { limit: 20, page: 0 },
    filter: {
      search,
    },
    params: undefined,
  });

  const onChange = () => {
    debouncedFunc('');
  };

  const onInputChange = (_: SyntheticEvent, v: string) => {
    debouncedFunc(v);
  };

  return (
    <Field.Autocomplete
      disabledFilterOptions
      fullWidth
      showRequiredMark
      label={t('operation.sections.mainInformationSection.fields.trader.label')}
      loading={loading}
      name="trader"
      optionLabelKey="label"
      options={(listData?.list ?? []).map((trader) => ({
        label: trader.name,
        value: trader.id,
      }))}
      optionValueKey="value"
      placeholder={t(
        'operation.sections.mainInformationSection.fields.trader.placeholder'
      )}
      onChange={onChange}
      onInputChange={onInputChange}
    />
  );
};
